import { useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'

const H = ({ style, ...p }: React.HTMLAttributes<HTMLElement>) => (
  <span style={{ fontFamily: "'Space Grotesk', sans-serif", ...style }} {...p} />
)

export default function LandingPage() {
  const navigate = useNavigate()
  const [isMobile, setIsMobile] = useState(false)
  const [isVerySmall, setIsVerySmall] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
      setIsVerySmall(window.innerWidth < 480)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div style={{ fontFamily: "'Manrope', sans-serif", background: '#f6f6ff', color: '#272e42', overflowX: 'hidden' }}>
      {/* ── Decorative blobs ── */}
      <div style={{ position: 'fixed', top: '-8rem', right: '-8rem', width: '40rem', height: '40rem', borderRadius: '50%', background: 'rgba(0,75,226,0.04)', filter: 'blur(80px)', pointerEvents: 'none', zIndex: 0 }} />
      <div style={{ position: 'fixed', bottom: '-10rem', left: '-10rem', width: '50rem', height: '50rem', borderRadius: '50%', background: 'rgba(142,0,213,0.04)', filter: 'blur(100px)', pointerEvents: 'none', zIndex: 0 }} />

      {/* ── Top Nav ── */}
      <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: isMobile ? (isVerySmall ? '0.5rem 1rem' : '0.625rem 1rem') : '0.875rem 2rem', background: 'rgba(255,255,255,0.65)', backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)', boxShadow: '0 20px 40px rgba(0,75,226,0.06)', gap: isMobile ? '0.5rem' : 'auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: isVerySmall ? '0.25rem' : '0.5rem', flexShrink: 0 }}>
          <div style={{ width: isVerySmall ? '1.75rem' : '2.25rem', height: isVerySmall ? '1.75rem' : '2.25rem', borderRadius: '0.75rem', background: 'linear-gradient(135deg,#004be2,#809bff)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(0,75,226,0.25)', flexShrink: 0 }}>
            <span className="material-symbols-outlined" style={{ color: 'white', fontSize: isVerySmall ? '1rem' : '1.25rem', fontVariationSettings: "'FILL' 1" }}>bolt</span>
          </div>
          <H style={{ fontWeight: 800, fontSize: isVerySmall ? '0.875rem' : isMobile ? '1rem' : '1.25rem', letterSpacing: '-0.03em', color: '#004be2', whiteSpace: 'nowrap' }}>EngHustle</H>
        </div>
        <div style={{ display: 'flex', gap: isVerySmall ? '0.375rem' : isMobile ? '0.5rem' : '0.75rem', flexShrink: 0 }}>
          <button onClick={() => navigate('/login')} style={{ padding: isVerySmall ? '0.4rem 0.75rem' : isMobile ? '0.5rem 0.875rem' : '0.625rem 1.25rem', borderRadius: '9999px', background: 'none', border: '1px solid rgba(165,173,198,0.3)', color: '#004be2', fontWeight: 700, fontSize: isVerySmall ? '0.7rem' : isMobile ? '0.75rem' : '0.875rem', cursor: 'pointer', fontFamily: "'Space Grotesk',sans-serif", whiteSpace: 'nowrap' }}>
            Đăng nhập
          </button>
          <button onClick={() => navigate('/register')} className="btn-primary" style={{ padding: isVerySmall ? '0.4rem 0.75rem' : isMobile ? '0.5rem 1rem' : '0.625rem 1.5rem', fontSize: isVerySmall ? '0.7rem' : isMobile ? '0.8125rem' : '0.875rem', whiteSpace: 'nowrap' }}>
            Bắt đầu miễn phí
          </button>
        </div>
      </nav>

      {/* ── Hero ── */}
      <section style={{ paddingTop: isMobile ? '5rem' : '7rem', paddingBottom: isMobile ? '3rem' : '5rem', paddingLeft: isMobile ? '1rem' : '2rem', paddingRight: isMobile ? '1rem' : '2rem', minHeight: '100vh', display: 'flex', alignItems: 'center', position: 'relative', zIndex: 1 }}>
        <div style={{ maxWidth: '90rem', margin: '0 auto', width: '100%', display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(20rem, 1fr))', gap: isMobile ? '2rem' : '4rem', alignItems: 'center' }}>
          <div>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.375rem 1rem', borderRadius: '9999px', background: 'rgba(0,75,226,0.08)', marginBottom: '1.5rem' }}>
              <span className="material-symbols-outlined" style={{ color: '#004be2', fontSize: '1rem' }}>auto_awesome</span>
              <span style={{ fontSize: '0.75rem', fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#004be2' }}>VSTEP Revolution 2026</span>
            </div>
            <H style={{ display: 'block', fontSize: isMobile ? 'clamp(1.75rem,5vw,2.5rem)' : 'clamp(3rem,7vw,5.5rem)', fontWeight: 900, letterSpacing: '-0.04em', lineHeight: 0.95, color: '#004be2', marginBottom: '1.5rem' }}>
              Chinh phục<br />
              VSTEP<br />
              <span style={{ color: '#8e00d5', fontStyle: 'italic' }}>15 phút/ngày</span>
            </H>
            <p style={{ fontSize: isMobile ? '1rem' : '1.125rem', color: '#535b71', maxWidth: '30rem', lineHeight: 1.7, marginBottom: '2.5rem' }}>
              AI phân tích Speaking và Writing ngay lập tức. Lộ trình cá nhân hoá theo điểm mạnh/yếu. Chứng chỉ tiếng Anh chuyên nghiệp được tăng tốc.
            </p>
            <div style={{ display: 'flex', gap: isMobile ? '0.75rem' : '1rem', flexWrap: 'wrap', flexDirection: isMobile ? 'column' : 'row' }}>
              <button
                onClick={() => navigate('/register')}
                className="btn-primary"
                style={{ padding: isMobile ? '0.875rem 1.5rem' : '1.125rem 2.5rem', fontSize: isMobile ? '0.9375rem' : '1.0625rem' }}
              >
                Bắt đầu miễn phí
                {!isMobile && <span className="material-symbols-outlined" style={{ fontSize: '1.25rem' }}>arrow_forward</span>}
              </button>
              {!isMobile && (
                <button
                  onClick={() => navigate('/library')}
                  className="btn-secondary"
                  style={{ padding: '1.125rem 2rem', fontSize: '1.0625rem' }}
                >
                  Xem chương trình
                </button>
              )}
            </div>

            {/* Social proof */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginTop: '2.5rem' }}>
              <div style={{ display: 'flex' }}>
                {['#004be2','#8e00d5','#006571','#b41340'].map((c, i) => (
                  <div key={i} style={{ width: '2.25rem', height: '2.25rem', borderRadius: '50%', background: c, border: '2px solid white', marginLeft: i > 0 ? '-0.75rem' : 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '0.625rem', fontWeight: 800 }}>
                    {['LP','MT','KN','VA'][i]}
                  </div>
                ))}
              </div>
              <div>
                <div style={{ fontWeight: 800, fontSize: '0.875rem' }}>10,000+ học viên</div>
                <div style={{ fontSize: '0.75rem', color: '#535b71' }}>đã cải thiện điểm VSTEP</div>
              </div>
            </div>
          </div>

          {/* Hero visual */}
          <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle, rgba(0,75,226,0.08) 0%, transparent 70%)', borderRadius: '50%', filter: 'blur(40px)' }} />
            <div style={{ position: 'relative', background: 'rgba(255,255,255,0.7)', backdropFilter: 'blur(24px)', borderRadius: '2rem', padding: '2rem', boxShadow: '0 32px 64px rgba(0,0,0,0.08)', border: '1px solid rgba(165,173,198,0.15)', width: '100%', maxWidth: '28rem', zIndex: 2 }}>
              {/* Mock AI feedback UI */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <div style={{ width: '0.75rem', height: '0.75rem', borderRadius: '50%', background: '#f74b6d' }} />
                  <div style={{ width: '0.75rem', height: '0.75rem', borderRadius: '50%', background: '#8e00d5' }} />
                  <div style={{ width: '0.75rem', height: '0.75rem', borderRadius: '50%', background: '#004be2' }} />
                </div>
                <span style={{ fontSize: '0.625rem', fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#535b71' }}>AI Real-time Feedback</span>
              </div>

              {/* Speech analysis card */}
              <div style={{ padding: '1.25rem', borderRadius: '1rem', background: '#eef0ff', marginBottom: '1rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
                  <span className="material-symbols-outlined" style={{ color: '#004be2', fontVariationSettings: "'FILL' 1" }}>psychology</span>
                  <span style={{ fontWeight: 700, fontSize: '0.875rem' }}>Phân tích Speaking</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-end', gap: '0.25rem', height: '3rem' }}>
                  {[40, 70, 90, 50, 80, 60, 95, 45, 75].map((h, i) => (
                    <div key={i} style={{ flex: 1, borderRadius: '4px 4px 0 0', background: i === 6 ? '#004be2' : 'rgba(0,75,226,0.25)', height: `${h}%`, animation: i === 6 ? 'pulse 1.5s ease-in-out infinite' : 'none' }} />
                  ))}
                </div>
              </div>

              {/* Writing feedback card */}
              <div style={{ padding: '1.25rem', borderRadius: '1rem', background: 'white', border: '1px solid rgba(0,75,226,0.08)' }}>
                <p style={{ fontSize: '0.8125rem', fontWeight: 600, marginBottom: '0.75rem', color: '#272e42' }}>Writing: "Tác động của AI trong giáo dục..."</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                  <span style={{ padding: '0.25rem 0.625rem', background: '#dcfce7', color: '#15803d', borderRadius: '0.375rem', fontSize: '0.75rem', fontWeight: 700 }}>Cohesion +1.2</span>
                  <span style={{ padding: '0.25rem 0.625rem', background: '#dbeafe', color: '#1d4ed8', borderRadius: '0.375rem', fontSize: '0.75rem', fontWeight: 700 }}>Từ vựng: Academic</span>
                  <span style={{ padding: '0.25rem 0.625rem', background: '#fee2e2', color: '#dc2626', borderRadius: '0.375rem', fontSize: '0.75rem', fontWeight: 700 }}>Grammar: Tense</span>
                </div>
              </div>
            </div>

            {/* Floating streak badge */}
            <div style={{ position: 'absolute', bottom: '-1.5rem', right: '-1.5rem', background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(16px)', borderRadius: '1rem', padding: '1rem 1.25rem', boxShadow: '0 16px 40px rgba(0,0,0,0.1)', display: 'flex', alignItems: 'center', gap: '0.75rem', zIndex: 3 }}>
              <div style={{ width: '2.75rem', height: '2.75rem', borderRadius: '50%', background: '#8e00d5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span className="material-symbols-outlined" style={{ color: 'white', fontVariationSettings: "'FILL' 1" }}>local_fire_department</span>
              </div>
              <div>
                <div style={{ fontSize: '0.625rem', fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#535b71' }}>Streak hiện tại</div>
                <H style={{ fontSize: '1.25rem', fontWeight: 900, color: '#272e42' }}>24 ngày 🔥</H>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Features bento ── */}
      <section style={{ padding: isMobile ? '3rem 1rem' : '5rem 2rem', background: '#eef0ff', position: 'relative', zIndex: 1 }}>
        <div style={{ maxWidth: '90rem', margin: '0 auto' }}>
          <div style={{ marginBottom: '3.5rem' }}>
            <H style={{ display: 'block', fontSize: isMobile ? 'clamp(1.5rem,5vw,2rem)' : 'clamp(2rem,4vw,3rem)', fontWeight: 900, letterSpacing: '-0.03em', marginBottom: '0.75rem' }}>Học thông minh hơn.</H>
            <p style={{ color: '#535b71', fontSize: isMobile ? '1rem' : '1.0625rem', maxWidth: '30rem' }}>Đừng học chăm hơn — học thông minh hơn với công nghệ thiết kế cho người học hiện đại.</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(18rem, 1fr))', gap: '1.5rem' }}>
            {[
              { icon: 'speed', title: 'Microlearning', desc: 'Bài học 15 phút cực kỳ tập trung — phù hợp với buổi sáng hoặc lúc di chuyển.', bg: 'rgba(255,255,255,0.7)', span: 2 },
              { icon: 'route', title: 'Lộ trình AI cá nhân', desc: 'AI phân tích điểm yếu trong Speaking & Writing để tạo roadmap hàng ngày.', bg: 'linear-gradient(135deg,#004be2,#809bff)', light: true },
              { icon: 'podcasts', title: 'Nội dung thực tế (TED/BBC)', desc: 'Học VSTEP qua TED Talks và BBC News. Ngữ cảnh thực tế — kỹ năng thực tế.', bg: 'rgba(255,255,255,0.7)', span: 2 },
              { icon: 'psychology', title: 'AI Pronunciation Coach', desc: 'Phân tích phiên âm chi tiết từng âm tiết. Phản hồi ngay lập tức.', bg: '#060e20', light: true },
            ].map((f, i) => (
              <div
                key={i}
                style={{
                  gridColumn: isMobile ? undefined : (f.span ? `span ${f.span}` : undefined),
                  padding: isMobile ? '1.5rem' : '2.5rem',
                  borderRadius: '2rem',
                  background: f.bg,
                  backdropFilter: !f.bg.startsWith('linear') ? 'blur(16px)' : undefined,
                  boxShadow: '0 16px 40px rgba(0,0,0,0.04)',
                  transition: 'transform 0.3s',
                  cursor: 'default',
                }}
                onMouseEnter={e => !isMobile && (e.currentTarget.style.transform = 'translateY(-4px)')}
                onMouseLeave={e => !isMobile && (e.currentTarget.style.transform = 'none')}
              >
                <span className="material-symbols-outlined" style={{ fontSize: '3rem', color: f.light ? 'rgba(255,255,255,0.8)' : '#004be2', marginBottom: '1.25rem', display: 'block', fontVariationSettings: "'FILL' 0" }}>{f.icon}</span>
                <H style={{ display: 'block', fontSize: '1.5rem', fontWeight: 800, marginBottom: '0.75rem', color: f.light ? 'white' : '#272e42' }}>{f.title}</H>
                <p style={{ color: f.light ? 'rgba(255,255,255,0.7)' : '#535b71', lineHeight: 1.7 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Pricing teaser ── */}
      <section style={{ padding: isMobile ? '3rem 1rem' : '5rem 2rem', position: 'relative', zIndex: 1 }}>
        <div style={{ maxWidth: '70rem', margin: '0 auto', textAlign: 'center', marginBottom: '3.5rem' }}>
          <H style={{ display: 'block', fontSize: isMobile ? 'clamp(1.5rem,5vw,2rem)' : 'clamp(2rem,4vw,3.5rem)', fontWeight: 900, letterSpacing: '-0.04em', lineHeight: 0.95, marginBottom: '1rem' }}>Chọn cường độ luyện tập.</H>
          <p style={{ color: '#535b71', fontSize: isMobile ? '1rem' : '1.0625rem' }}>Mở khóa toàn bộ sức mạnh AI với các gói học phù hợp.</p>
        </div>

        <div style={{ maxWidth: '56rem', margin: '0 auto', display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(20rem, 1fr))', gap: '2rem' }}>
          {/* Free */}
          <div style={{ padding: isMobile ? '1.5rem' : '3rem', borderRadius: '2.5rem', background: 'rgba(255,255,255,0.7)', backdropFilter: 'blur(16px)', boxShadow: '0 16px 40px rgba(0,0,0,0.04)', display: 'flex', flexDirection: 'column' }}>
            <H style={{ display: 'block', fontSize: '1.75rem', fontWeight: 800, marginBottom: '0.5rem' }}>Hustle Free</H>
            <p style={{ color: '#535b71', marginBottom: '1.5rem', fontSize: '0.9375rem' }}>Hoàn hảo để bắt đầu.</p>
            <div style={{ marginBottom: '2rem' }}>
              <H style={{ fontSize: '3rem', fontWeight: 900 }}>$0</H>
              <span style={{ color: '#535b71' }}>/tháng</span>
            </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 2rem 0', flex: 1, display: 'flex', flexDirection: 'column', gap: '0.875rem' }}>
              {['Session 15 phút/ngày', 'Mock test cơ bản', 'Hỗ trợ cộng đồng'].map(f => (
                <li key={f} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <span className="material-symbols-outlined" style={{ color: '#004be2', fontSize: '1.25rem', fontVariationSettings: "'FILL' 1" }}>check_circle</span>
                  <span style={{ fontSize: '0.9375rem', fontWeight: 500 }}>{f}</span>
                </li>
              ))}
              {['Phân tích AI nâng cao', 'Lộ trình cá nhân hoá'].map(f => (
                <li key={f} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', opacity: 0.35 }}>
                  <span className="material-symbols-outlined" style={{ fontSize: '1.25rem' }}>block</span>
                  <span style={{ fontSize: '0.9375rem', fontWeight: 500 }}>{f}</span>
                </li>
              ))}
            </ul>
            <button onClick={() => navigate('/register')} style={{ padding: '1rem', borderRadius: '9999px', background: 'none', border: '2px solid rgba(165,173,198,0.3)', fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: '0.9375rem', color: '#272e42', cursor: 'pointer', transition: 'all 0.2s' }}>
              Bắt đầu ngay
            </button>
          </div>

          {/* Premium */}
          <div style={{ padding: isMobile ? '1.5rem' : '3rem', borderRadius: '2.5rem', background: 'white', boxShadow: '0 0 0 2px transparent, 0 32px 64px rgba(0,75,226,0.15)', outline: '2px solid transparent', backgroundImage: 'linear-gradient(white,white), linear-gradient(135deg,#004be2,#809bff)', backgroundClip: 'padding-box', border: '2px solid transparent', display: 'flex', flexDirection: 'column', position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', top: 0, right: 0, width: '8rem', height: '8rem', background: 'rgba(0,75,226,0.05)', borderRadius: '0 2.5rem 0 100%' }} />
            <div style={{ display: 'inline-flex', marginBottom: '1rem' }}>
              <span style={{ padding: '0.25rem 0.875rem', borderRadius: '9999px', background: 'rgba(0,75,226,0.08)', color: '#004be2', fontSize: '0.625rem', fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase' }}>PHỔ BIẾN NHẤT</span>
            </div>
            <H style={{ display: 'block', fontSize: '1.75rem', fontWeight: 800, marginBottom: '0.5rem', color: '#004be2' }}>Hustle Premium</H>
            <p style={{ color: '#535b71', marginBottom: '1.5rem', fontSize: '0.9375rem' }}>Sức mạnh đầy đủ cho thí sinh nghiêm túc.</p>
            <div style={{ marginBottom: '2rem' }}>
              <H style={{ fontSize: '3rem', fontWeight: 900 }}>150.000đ</H>
              <span style={{ color: '#535b71' }}>/tháng</span>
            </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 2rem 0', flex: 1, display: 'flex', flexDirection: 'column', gap: '0.875rem' }}>
              {['Phiên học không giới hạn', 'AI Writing Coach nâng cao', 'AI Speaking Coach + phát âm', 'Từ vựng không giới hạn', 'Mock Test 4 kỹ năng đầy đủ', 'Báo cáo chi tiết + AI tutor', 'Ưu tiên ghép Study Buddy', 'Hỗ trợ 24/7'].map(f => (
                <li key={f} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <span className="material-symbols-outlined" style={{ color: '#8e00d5', fontSize: '1.25rem', fontVariationSettings: "'FILL' 1" }}>verified</span>
                  <span style={{ fontSize: '0.9375rem', fontWeight: 700 }}>{f}</span>
                </li>
              ))}
            </ul>
            <button
              disabled
              style={{ padding: '1.125rem', width: '100%', fontSize: '1rem', borderRadius: '9999px', border: 'none', background: 'rgba(0,75,226,0.15)', color: 'rgba(39,46,66,0.5)', fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, cursor: 'not-allowed' }}
            >
              Sắp ra mắt — Coming Soon
            </button>
          </div>
        </div>
      </section>

      {/* ── CTA Banner ── */}
      <section style={{ padding: isMobile ? '2rem 1rem 3rem' : '3rem 2rem 5rem', position: 'relative', zIndex: 1 }}>
        <div style={{ maxWidth: '70rem', margin: '0 auto', background: 'rgba(255,255,255,0.7)', backdropFilter: 'blur(24px)', borderRadius: '3rem', padding: isMobile ? '2rem 1.5rem' : '4rem 3rem', textAlign: 'center', position: 'relative', overflow: 'hidden', boxShadow: '0 32px 64px rgba(0,0,0,0.06)' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'linear-gradient(135deg, rgba(0,75,226,0.04) 0%, rgba(142,0,213,0.04) 100%)', pointerEvents: 'none' }} />
          <H style={{ display: 'block', fontSize: isMobile ? 'clamp(1.25rem,5vw,1.75rem)' : 'clamp(1.75rem,4vw,3rem)', fontWeight: 900, letterSpacing: '-0.03em', lineHeight: 1.1, marginBottom: '1rem', position: 'relative' }}>
            Sẵn sàng nâng cấp{' '}
            <span style={{ color: '#004be2', fontStyle: 'italic' }}>EngHustle</span>?
          </H>
          <p style={{ fontSize: isMobile ? '1rem' : '1.125rem', color: '#535b71', marginBottom: '2.5rem', position: 'relative', maxWidth: '32rem', margin: '0 auto 2.5rem' }}>
            Tham gia cùng hơn 10,000 học viên đang chinh phục VSTEP với nền tảng AI microlearning.
          </p>
          <button
            onClick={() => navigate('/register')}
            className="btn-primary"
            style={{ padding: isMobile ? '1rem 1.5rem' : '1.25rem 3rem', fontSize: isMobile ? '1rem' : '1.0625rem', position: 'relative' }}
          >
            Bắt đầu miễn phí
          </button>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer style={{ padding: isMobile ? '2rem 1rem' : '3rem 2rem', background: '#f8f9fe', borderTop: '1px solid rgba(165,173,198,0.15)' }}>
        <div style={{ maxWidth: '90rem', margin: '0 auto', display: 'flex', flexWrap: 'wrap', justifyContent: isMobile ? 'center' : 'space-between', alignItems: 'center', gap: '2rem', textAlign: isMobile ? 'center' : 'left' }}>
          <div>
            <H style={{ display: 'block', fontWeight: 900, fontSize: '1.25rem', color: '#004be2', marginBottom: '0.25rem' }}>EngHustle</H>
            <p style={{ fontSize: '0.75rem', letterSpacing: '0.1em', textTransform: 'uppercase', color: '#6f768e' }}>© 2026 EngHustle AI. Kinetic Fluidity Framework.</p>
          </div>
          {!isMobile && (
            <div style={{ display: 'flex', gap: '2rem' }}>
              {['Bảo mật', 'Điều khoản', 'Hỗ trợ', 'API'].map(l => (
                <button key={l} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6f768e', fontSize: '0.8125rem', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', fontFamily: "'Manrope',sans-serif" }}>{l}</button>
              ))}
            </div>
          )}
        </div>
      </footer>
    </div>
  )
}
